export const publicDisclosurePreferencePayload = (preference) => ({
  master_enabled: Boolean(preference?.master_enabled),
  bell_enabled: Boolean(preference?.bell_enabled),
  daily_briefing_enabled: Boolean(preference?.daily_briefing_enabled),
  corporate_insider_enabled: Boolean(preference?.corporate_insider_enabled),
  congressional_enabled: Boolean(preference?.congressional_enabled),
});

export const publicDisclosurePreferenceSummary = (preference) => {
  if (!preference?.master_enabled) return 'Public Disclosure Alerts are turned off.';
  const channels = [
    preference.bell_enabled ? 'Bell' : null,
    preference.daily_briefing_enabled ? 'Daily Briefing' : null,
  ].filter(Boolean);
  return channels.length
    ? channels.join(' + ') + ' enabled'
    : 'Alerts are on. Choose delivery channels in Account settings.';
};
